import React from "react"
import Slider from "react-slick/lib"

export default class SimpleSlider extends React.Component {

  state = {
    isDragging: false
  }

  toggleDragging = () => this.setState( { isDragging: !this.state.isDragging } );
  onClickHandler = ( event ) => {
    if ( this.props.isDragging ) {
      event.preventDefault();
    } else {
      return true
    }
  };

  render() {

    const { slidesToShow = 4, slidesToScroll = 1, centerMode = false, centerPadding = "0px", dots = true } = this.props
    const settings = {
      dots,
      infinite: true,
      speed:    500,
      arrows:   true,
      slidesToShow,
      slidesToScroll,
      centerMode,
      centerPadding,
    };

    const { isDragging } = this.state
    return (
      <React.Fragment>
        <Slider {...settings}
        >
          {this.props.children}
        </Slider>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Product/SimpleSlider.js